export default "__VITE_ASSET__rOZSt_hp__"